<div class="content-block">

  <!-- Content Header (Page header) -->

  <!--<div class="content-header">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-6">
        <h1 class="m-0 text-dark">Movimenti articoli <b><span *ngIf="firmati">Firmati</span> <span *ngIf="!firmati">Da Firmare</span></b></h1>
      </div>
      <div class="col-sm-6">
        <ol class="breadcrumb float-sm-right">
          <li class="breadcrumb-item"><a href="/home">Dashboard</a></li>
          <li class="breadcrumb-item">Magazzino</li>
          <li class="breadcrumb-item active"><span *ngIf="firmati">Firmati</span> <span *ngIf="!firmati">Da Firmare</span></li>
        </ol>
      </div>
    </div>
  </div>
</div>
-->

  <div class="content-header">
    <div class="row">
      <div class="col-12">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h2 class="content-block">Movimenti articoli <b>@if (firmati) {
              <span>Firmati</span>
              } @if (!firmati) {
              <span>Da Firmare</span>
              }</b></h2>
          <div class="d-flex gap-4">
            <app-btn-nuova-consegna></app-btn-nuova-consegna>
          </div>
        </div>
      </div>
    </div>
  </div>




  <div class="card primary">
    <!--<div class="card-header">
  <h3 class="card-title">
    <i class="fa fa-chart-pie mr-1"></i>
    <span *ngIf="firmati">Firmati</span> <span *ngIf="!firmati">Da Firmare</span>
  </h3>

</div>-->
    <div class="card-body">
      <dx-data-grid [dataSource]="dataSource" [showBorders]="true" [focusedRowEnabled]="true" [focusedRowIndex]="0"
        [columnAutoWidth]="true" [columnHidingEnabled]="true" [showColumnLines]="true" [showRowLines]="true"
        [rowAlternationEnabled]="true" (onInitNewRow)="onInitNewRow()" (onRowRemoved)="onRowRemoved()"
        [masterDetail]="{ enabled: true, template: 'detail' }" (onExporting)="onExporting($event)">

        <dxo-export [enabled]="true"></dxo-export>
        <dxo-editing mode="popup" [allowAdding]="true" [allowUpdating]="false" [allowDeleting]="!firmati"
          [useIcons]="true">
          <dxo-texts confirmDeleteMessage="Confermare la cancellazione?"></dxo-texts>
        </dxo-editing>

        <dxo-paging [pageSize]="10"></dxo-paging>
        <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxi-column type="buttons" [buttons]="['edit', 'delete']"></dxi-column>
        @if (firmati) {
        <dxi-column name="fileOptions" [formItem]="{ visible: false }" [allowFiltering]="false" [allowSorting]="false"
          cellTemplate="scaricaPDF" width="30" caption="">
        </dxi-column>
        }
        <div *dxTemplate="let d of 'scaricaPDF'">
          @if (d.data.firmato && d.data.allegato != null) {
          <i class="dx-icon-pdffile" (click)="scaricaFile(d.data)" data-toggle="tooltip" data-placement="top"
            title="Scarica documento"></i>
          }
        </div>
        @if (!firmati) {
        <dxi-column name="firmaDoc" [formItem]="{ visible: false }" [allowFiltering]="false" [allowSorting]="false"
          cellTemplate="firmaDocTemplate" width="30" caption="">
        </dxi-column>
        }
        <dxi-column name="addFileAllegato" [formItem]="{ visible: false }" dataField="id" [allowFiltering]="false"
          [allowSorting]="false" cellTemplate="aggiungiAllegatoTemplate" width="30" caption="">
        </dxi-column>
        <dxi-column dataField="id" [visible]="false">
        </dxi-column>
        <dxi-column dataField="progr" [visible]="false">
        </dxi-column>
        <dxi-column dataField="data" format="dd/MM/yyyy" dataType="date" width="80" [sortIndex]="1" sortOrder="desc">
        </dxi-column>
        <dxi-column dataField="qta" width="70">
        </dxi-column>
        <dxi-column dataField="idArticolo" caption="Articolo" width="300">
          <dxo-lookup [dataSource]="listArticoli" valueExpr="id" [displayExpr]="displayArticolo"></dxo-lookup>
        </dxi-column>
        @if (gestMatricole) {
        <dxi-column dataField="idArticoloMatricola" caption="Matricola" width="300">
          <dxo-lookup [dataSource]="listArticoliMatricola" valueExpr="id" displayExpr="matricola"></dxo-lookup>
        </dxi-column>
        }
        <dxi-column dataField="idDipendente" caption="Dipendente">
          <dxo-lookup [dataSource]="listDip" valueExpr="id" displayExpr="nominativo"></dxo-lookup>
        </dxi-column>

        <dxi-column dataField="cambio" dataType="boolean" [visible]="false">
        </dxi-column>
        <dxi-column dataField="dettagli" [visible]="false">
        </dxi-column>
        <dxi-column dataField="firmato" dataType="boolean" [visible]="false">
        </dxi-column>

        <div *dxTemplate="let d of 'firmaDocTemplate'">
          @if (!d.data.firmato) {
          <i class="dx-icon-rename" (click)="firmaDocumento(d.data)" data-toggle="tooltip" data-placement="top"
            title="Firma documento"></i>
          }
        </div>


        <div *dxTemplate="let d of 'aggiungiAllegatoTemplate'">
          <i (click)="goToAllegaMov(d.value)" style="cursor: pointer;" class="dx-icon-upload" data-toggle="tooltip"
            data-placement="top" title="Aggiungi allegato"></i>
        </div>

        <div *dxTemplate="let mov of 'detail'">
          <div class="master-detail-caption">{{"Allegati del movimento " + mov.data.id}}</div>
          <dx-data-grid [dataSource]="getAllegati(mov.data.id)" [showBorders]="true" [columnAutoWidth]="true">
            <dxi-column dataField="id" [visible]="false"></dxi-column>

            <dxi-column name="scaricaFileAllegato" [allowFiltering]="false" [allowSorting]="false"
              cellTemplate="scaricaFileAllegato" caption="" width="30">
            </dxi-column>
            <dxi-column name="vediFile" [allowFiltering]="false" [allowSorting]="false" cellTemplate="vediFile"
              caption="" width="30">
            </dxi-column>
            <dxi-column name="deleteFile" [allowFiltering]="false" [allowSorting]="false" cellTemplate="deleteFile"
              caption="" width="30">
            </dxi-column>

            <dxi-column dataField="nome"></dxi-column>
            <div *dxTemplate="let d of 'scaricaFileAllegato'">
              <i class="dx-icon-download" (click)="scaricaFileAllegato(d.data)" style="cursor: pointer;"
                data-toggle="tooltip" data-placement="top" title="Scarica allegato"></i>
            </div>
            <div *dxTemplate="let d of 'vediFile'">
              @if (endsWith(d.data.nomeFile, '.jpg') || endsWith(d.data.nomeFile, '.png')) {
              <i class="dx-icon-image" (click)="visualizzaImmagine(d.data)" style="cursor: pointer;"
                data-toggle="tooltip" data-placement="top" title="Visualizza immagine"></i>
              }
              @if (endsWith(d.data.nomeFile, '.pdf')) {
              <i class="dx-icon-doc" (click)="visualizzaFile(d.data)" style="cursor: pointer;" data-toggle="tooltip"
                data-placement="top" title="Visualizza allegato"></i>
              }
            </div>
            <div *dxTemplate="let d of 'deleteFile'">
              <i class="dx-icon-trash" (click)="eliminaFile(d.data)" style="cursor: pointer;" data-toggle="tooltip"
                data-placement="top" title="Elimina allegato"></i>
            </div>
          </dx-data-grid>
        </div>

        <dxo-paging [pageSize]="20">
        </dxo-paging>
        <dxo-pager visible="true" allowedPageSizes="true" displayMode="full" showPageSizeSelector="true" showInfo="true"
          showNavigationButtons="true">
        </dxo-pager>
      </dx-data-grid>

    </div><!-- /.card-body -->
  </div>
  <!-- /.card -->



</div>



<!--
<h2 class="content-block">Movimenti Dpi <span *ngIf="firmati">Firmati</span> <span *ngIf="!firmati">Da Firmare</span></h2>
<div class="content-block">
  <div class="row">
    <div class="col-12">

    </div>
  </div>
</div>
-->
<dx-popup [width]="600" [height]="450" [showTitle]="true" title="Information" [dragEnabled]="false"
  [hideOnOutsideClick]="true" [(visible)]="popupImageVisible">
  <img style="max-width: 100%; max-height: 100%;" [src]="currentImage" alt="Immagine Allegato Movimento">
</dx-popup>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadPanelVisible" [showIndicator]="true"
  [showPane]="true" [shading]="true" [hideOnOutsideClick]="false">
</dx-load-panel>